export default "/images/41ade224216c6e040d4815aa79cb64b6.avif";